import React, { useState, useEffect, useRef } from "react";
import { Drawer, Form, InputNumber, Icon, Modal, notification } from "antd";
import axios from "axios";
const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message,
        description
    });
};
export default function DrawerQuestoes({
    cursoId,
    visible,
    onClose,
    avaliacao = {},
    notasQuestoes = {},
    onAlterarNotaQuestao,
    onGuardarNotas,
    loadingGuardarNotas = false,
    exportarAvaliacao
}) {
    const nomeAvaliacao = avaliacao?.nome || "Avaliação";
    const questoes = avaliacao?.alunos?.questoes || [];
    const [notasOriginais, setNotasOriginais] = useState({});
    const isDrawerOpen = useRef(false);

    useEffect(() => {
        if (visible && !isDrawerOpen.current) setNotasOriginais({ ...notasQuestoes });
        isDrawerOpen.current = visible;
    }, [visible, notasQuestoes]);

    const temAlteracoes = questoes.some(questao => (notasQuestoes[questao.id] ?? null) !== (notasOriginais[questao.id] ?? null));

    const handleGuardarNotas = async () => {
        const notasEnviadas = { ...notasQuestoes };
        const guardado = await onGuardarNotas();
        if (guardado === true) setNotasOriginais(notasEnviadas);
    };

    return (
        <>
            <Drawer
                className="drawer-from-questionario"
                //title="Avaliação"
                width={720}
                visible={visible}
                style={{
                    overflow: "auto",
                    height: "calc(100% - 108px)",
                    paddingBottom: "108px"
                }}
                onClose={loadingGuardarNotas ? undefined : onClose}
                closable={!loadingGuardarNotas}
                keyboard={!loadingGuardarNotas}
                maskClosable={false}
            >
                <div className="bloco-info">
                    <Form className="form-aula lista-questoes" layout="horizontal" hideRequiredMark>
                        <div className="avaliacao">
                            <h2 className="avaliacao-titulo">Questões da Avaliação - {nomeAvaliacao}</h2>
                            {questoes.map((questao, index) => {
                                const opcoes = questao.opcoes || [];
                                const respostasAluno = questao.respostaAluno || [];
                                const escolhaMultipla = questao.tipo_pergunta === "Escolha múltipla";
                                const respostaLivre = questao.tipo_pergunta === "Resposta livre";
                                const estaSelecionada = opcao => respostasAluno.some(resposta => resposta.id === opcao.id);
                                const corretas = opcoes.filter(opcao => opcao.verdadeiro);
                                const selecionadas = opcoes.filter(estaSelecionada);
                                const acertouEscolhaUnica = selecionadas.length === 1 && selecionadas[0].verdadeiro;
                                return (
                                    <section className="avaliacao-questao" key={questao.id}>
                                        <h3>
                                            Questão {index + 1} - {questao.pergunta}
                                        </h3>
                                        <p>Resposta:</p>
                                        {respostaLivre ? (
                                            <>
                                                <div>{questao.respostaLivre || ""}</div>
                                                {questao.texto_resolucao?.trim() && (
                                                    <p className="avaliacao-solucao">Solução: {questao.texto_resolucao}</p>
                                                )}
                                            </>
                                        ) : (
                                            <>
                                                <div className="avaliacao-opcoes">
                                                    {opcoes.map(opcao => {
                                                        const selecionada = estaSelecionada(opcao);
                                                        const mostrarCorrecao = escolhaMultipla && (opcao.verdadeiro || selecionada);
                                                        return (
                                                            <div key={opcao.id} className="avaliacao-opcao">
                                                                <span
                                                                    className={[
                                                                        "avaliacao-marcador",
                                                                        escolhaMultipla ? "marcador-quadrado" : "marcador-circulo",
                                                                        selecionada ? "marcador-selecionado" : ""
                                                                    ].join(" ")}
                                                                    role="img"
                                                                    aria-label={
                                                                        selecionada
                                                                            ? "Selecionada pelo aluno"
                                                                            : "Não selecionada pelo aluno"
                                                                    }
                                                                />
                                                                {escolhaMultipla && (
                                                                    <span className="avaliacao-correcao">
                                                                        {mostrarCorrecao && (
                                                                            <Icon type={opcao.verdadeiro ? "check" : "close"} />
                                                                        )}
                                                                    </span>
                                                                )}
                                                                <span className="avaliacao-texto">{opcao.texto}</span>
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                                {selecionadas.length === 0 ? (
                                                    <p className="avaliacao-resultado">O aluno não respondeu.</p>
                                                ) : !escolhaMultipla ? (
                                                    <p className="avaliacao-resultado">
                                                        {acertouEscolhaUnica ? "Certo" : "Errado"}
                                                        <Icon type={acertouEscolhaUnica ? "check" : "close"} />
                                                    </p>
                                                ) : null}
                                                <p className="avaliacao-solucao">
                                                    {escolhaMultipla ? "Respostas corretas: " : "Resposta correta: "}
                                                    {corretas.length > 0
                                                        ? corretas.map(opcao => opcao.texto).join("; ")
                                                        : "Sem resposta correta definida."}
                                                </p>
                                            </>
                                        )}
                                        <div className="avaliacao-nota">
                                            <label htmlFor={`nota-questao-${questao.id}`}>Nota da questão</label>
                                            <InputNumber
                                                id={`nota-questao-${questao.id}`}
                                                size="large"
                                                min={0}
                                                max={questao.pontuacao}
                                                placeholder="Nota"
                                                disabled={loadingGuardarNotas}
                                                value={notasQuestoes[questao.id] ?? null}
                                                onChange={valor => onAlterarNotaQuestao(questao.id, valor)}
                                            />
                                            <span className="avaliacao-nota-limite">Pontuação máxima: {questao.pontuacao}</span>
                                        </div>
                                    </section>
                                );
                            })}
                        </div>
                    </Form>
                </div>
                <div className="ant-drawer-footer">
                    <button
                        className="botao-secundario"
                        type="button"
                        onClick={onClose}
                        disabled={loadingGuardarNotas}
                        style={{ marginRight: 20 }}
                    >
                        Voltar
                    </button>
                    <button
                        className="botao-principal"
                        type="button"
                        onClick={handleGuardarNotas}
                        disabled={loadingGuardarNotas}
                        style={{ marginRight: 20 }}
                    >
                        {loadingGuardarNotas && <Icon type="loading" style={{ marginRight: 8 }} />}
                        Guardar
                    </button>
                    <button
                        className="botao-principal"
                        type="button"
                        onClick={() => exportarAvaliacao(cursoId, avaliacao.id, avaliacao.alunos?.id_utilizador)}
                        disabled={temAlteracoes}
                    >
                        Gerar Documento
                    </button>
                </div>
            </Drawer>
        </>
    );
}
